import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';
import { Button } from '@codex-brightworld/basics';

const ButtonsWrapper = styled.div`
  text-align: center;
  background: transparent;
  @media ${(props) => props.theme.breakpoints.mobile} {
    margin-bottom: 10px;
  }
`;

const StyledButton = styled(Button)`
  @font-face {
    font-family: 'CurrysSans';
    src: url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Regular.woff') format('woff'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Regular.otf') format('truetype'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Regular.eot?') format('embedded-opentype');
  }
  font-family: CurrysSans;
  font-size: 16px;
`;

const StyledLink = styled.a.attrs((props) => (
  {
    'data-interaction': props.interaction
  }
))`
  font-family: CurrysSans;
  font-size: 14px;
  color: ${(props) => props.theme.colors.primary.purple};
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

const LinkWrapper = styled.div`
  padding: 11px 0 16px 0;
  height: 14px;
  line-height: 16px;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
     /* IE10+ CSS styles go here */
     padding: 11px 0 26px 0;
  }
  @media ${(props) => props.theme.breakpoints.mobile} {
    margin-top: 11px;
    padding: 0;
  }
`;

export default function ActionButtons(props) {
  return (
    <EnvironmentThemeProvider>
      <ButtonsWrapper>
        <StyledButton
          primary
          onClick={props.primaryButtonOnClick}
          data-interaction={'Continue to basket'}
        >
          {props.primaryButtonLabel}
        </StyledButton>
        <LinkWrapper>
          <StyledLink onClick={props.secondaryButtonOnClick} interaction={'Continue shopping'}>
            {props.secondaryButtonLabel}
          </StyledLink>
        </LinkWrapper>
      </ButtonsWrapper>
    </EnvironmentThemeProvider>
  );
}

ActionButtons.propTypes = {
  primaryButtonOnClick: PropTypes.func,
  primaryButtonLabel: PropTypes.string.isRequired,
  secondaryButtonOnClick: PropTypes.func,
  secondaryButtonLabel: PropTypes.string.isRequired
};

ActionButtons.defaultProps = {
  primaryButtonOnClick: () => {},
  secondaryButtonOnClick: () => {}
};
